module.exports = __webpack_public_path__ + "img/矩形 2628.60f73d64.png";